const PALETTE = ["#6366F1", "#0EA5E9", "#F59E0B", "#10B981", "#EC4899"];

const List = ({ title, data }) => {
    const total = data.reduce((sum, item) => sum + item.visitors, 0);

    return (
        <div>
            <h3 className="mb-3 text-xs font-semibold uppercase tracking-wide text-slate-500">
                {title}
            </h3>

            <div className="space-y-3">
                {data.slice(0, 5).map((item, i) => {
                    const percent = total ? ((item.visitors / total) * 100).toFixed(1) : 0;
                    const color = PALETTE[i % PALETTE.length];

                    return (
                        <div key={item.label}>
                            <div className="mb-1 flex justify-between gap-2 text-xs">
                                <span className="truncate text-slate-600" title={item.label}>{item.label}</span>
                                <span className="shrink-0 font-semibold text-slate-900">{percent}%</span>
                            </div>
                            <div className="h-1.5 rounded-full bg-slate-100">
                                <div className="h-1.5 rounded-full" style={{ width: `${percent}%`, backgroundColor: color }} />
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

const AudienceTechnology = ({ browsers, operatingSystems }) => {
    return (
        <div className="rounded-xl border border-slate-200 bg-gradient-to-br from-violet-50/30 to-white p-5">
            <h2 className="mb-4 text-sm font-semibold text-slate-900">Technology Breakdown</h2>
            <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
                <List title="Browsers" data={browsers} />
                <List title="Operating Systems" data={operatingSystems} />
            </div>
        </div>
    );
};

export default AudienceTechnology;